import { render, staticRenderFns } from "./Low-activity.vue?vue&type=template&id=cf1130a8&"
import script from "./Low-activity.vue?vue&type=script&lang=js&"
export * from "./Low-activity.vue?vue&type=script&lang=js&"
import style0 from "./Low-activity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports